module.exports = __webpack_public_path__ + "img/ata-line.4130a25e.png";